/**
 * Determines if a page title indicates a loading state that should not be tracked
 * by analytics services (Google Analytics, custom analytics, etc.)
 * 
 * @param title - The page title to check
 * @returns true if the title indicates loading state, false if ready to track
 */
export function isLoadingTitle(title: string): boolean {
  if (!title || title.trim() === '') return true;
  
  // Handle string representations of null/undefined
  if (title === 'null' || title === 'undefined') return true;
  
  // Check for incomplete titles (likely auth redirects)
  if (title.startsWith('| ') || title.endsWith(' |') || title.trim() === '|') return true;
  
  // Check for default site title before content-specific titles load
  if (title === 'Welcome | International Polo') return true;
  
  // Check for undefined data in computed titles
  if (title.includes('undefined')) return true;
  
  // Check for loading patterns using regex (case insensitive)
  // Matches: "Loading...", "Loading courses", "Loading lesson...", etc.
  const loadingRegex = /loading(\s+(lesson|course|courses|profile|content|page|data))?(\.\.\.|\.)?/i;
  
  return loadingRegex.test(title);
}

/**
 * Configuration for MutationObserver to detect all types of title changes
 * Includes childList for DOM node changes, subtree for nested changes, 
 * and characterData for text content changes (useTitle/useSeoMeta updates)
 */
export const titleObserverConfig = {
  childList: true,
  subtree: true,
  characterData: true
};